export default "__VITE_ASSET__CVWY5mPV__"